<template>
    <HeaderContent title="Package Preview" />
    <BCard>
        <BRow class="mb-4">
            <BCol class="text-start">
                <span class="fw-bold">Package Name</span>
                <p>{{ packageItems?.name ?? "-" }}</p>
            </BCol>
            <BCol class="text-start">
                <span class="fw-bold">Pax</span>
                <p>{{ packageItems?.pax ?? "-" }}</p>
            </BCol>
            <BCol class="text-start">
                <span class="fw-bold">Duration Days</span>
                <p>{{ packageItems?.duration_days ?? "-" }}</p>
            </BCol>
        </BRow>
        <BRow class="mb-4">
            <BCol>
                <div class="table-responsive bg-white">
                    <table class="table table-sm">
                        <thead class="table-secondary">
                            <tr>
                                <th class="text-center">Day</th>
                                <th class="text-left">Name</th>
                                <th class="text-left">Destination From</th>
                                <th class="text-left">Destination To</th>
                                <th class="text-left">Accommodation</th>
                                <th class="text-left">Transportation</th>
                                <th class="text-left">Activity</th>
                                <th class="text-left">Meal</th>
                                <th class="text-right">Sub Total</th>
                                <th class="text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, index) in packageItems?.program"
                                :key="index"
                            >
                                <td class="text-center">
                                    {{ item.day }}
                                </td>
                                <td class="text-left">
                                    {{ item.name }}
                                </td>
                                <td class="text-left">
                                    {{ item.from_destination.name }}
                                </td>
                                <td class="text-left">
                                    {{ item.to_destination.name }}
                                </td>
                                <td class="text-left">
                                    <ul class="pl-3">
                                        <li
                                            v-for="(
                                                acc, accIndex
                                            ) in item.accommodation"
                                            :key="accIndex"
                                        >
                                            {{ acc.name }}
                                        </li>
                                    </ul>
                                </td>
                                <td class="text-left">
                                    <ul class="pl-3">
                                        <li
                                            v-for="(
                                                trp, trIndex
                                            ) in item.transportation"
                                            :key="trIndex"
                                        >
                                            {{ trp.name }}
                                        </li>
                                    </ul>
                                </td>
                                <td class="text-left">
                                    <ul class="pl-3">
                                        <li
                                            v-for="(
                                                act, actIndex
                                            ) in item.activity"
                                            :key="actIndex"
                                        >
                                            {{ act.name }}
                                        </li>
                                    </ul>
                                </td>
                                <td class="text-left">
                                    <ul class="pl-3">
                                        <li
                                            v-for="(
                                                meal, mealIndex
                                            ) in item.meals"
                                            :key="mealIndex"
                                        >
                                            {{ meal.name }}
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    {{ formatRupiah(item.price) }}
                                </td>
                                <td class="text-left">
                                    <router-link
                                        class="btn btn-sm btn-success px-2 py-1 me-2"
                                        :to="`/packages/program/${item.uuid}`"
                                    >
                                        <i class="fas fa-edit"></i>
                                    </router-link>
                                    <button
                                        @click="showDetail(item)"
                                        class="btn btn-sm btn-primary px-2 py-1"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="bottom"
                                        title="Detail"
                                    >
                                        <i class="fas fa-info-circle"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!packageItems?.program.length">
                                <td class="text-center" colspan="9">
                                    No data available
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="7" class="text-left">
                                    <strong>Grand Total</strong>
                                </td>
                                <td
                                    colspan="2"
                                    class="bg-success text-white text-right"
                                >
                                    <strong>{{
                                        formatRupiah(packageItems?.price)
                                    }}</strong>
                                </td>
                                <td class="bg-success text-white"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </BCol>
        </BRow>

        <BRow class="mb-4">
            <BCol class="text-start">
                <span class="fw-bold">Inclusion</span>
                <ul v-if="packageItems?.inclusion">
                    <li
                        v-for="(item, index) in packageItems.inclusion.split(
                            '\n'
                        )"
                        :key="index"
                    >
                        {{ item }}
                    </li>
                </ul>
                <p v-else>-</p>
            </BCol>
        </BRow>
        <BRow class="mb-4">
            <BCol class="text-start">
                <span class="fw-bold">Exclusion</span>
                <ul v-if="packageItems?.exclusion">
                    <li
                        v-for="(item, index) in packageItems.exclusion.split(
                            '\n'
                        )"
                        :key="index"
                    >
                        {{ item }}
                    </li>
                </ul>
                <p v-else>-</p>
            </BCol>
        </BRow>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton @click="save" variant="primary" class="me-2"
                    >Save</BButton
                >
                <BButton
                    type="button"
                    @click="
                        () => router.push('/packages/edit/' + route.params.uuid)
                    "
                    variant="secondary"
                    >Edit</BButton
                >
            </div>
        </template>
    </BCard>
    <ProgramPreview
        :modal="modal"
        :selectedData="selectedData"
        @update:modal="updateModal"
    ></ProgramPreview>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { formatRupiah } from "@/utils/format";
import { BButton, BCard, BCol, BRow } from "bootstrap-vue-next";
import { useToast } from "vue-toastification";
import ProgramPreview from "./program/ProgramPreviewOld.vue";

const auth = useAuthStore();
const $loading = useLoading();

const route = useRoute();
const router = useRouter();
const toast = useToast();
const selectedData = ref({});
const modal = ref(false);

const updateModal = (newValue) => {
    modal.value = newValue;
};

const showDetail = (item) => {
    console.log(item);
    selectedData.value = item;
    modal.value = true;
};

const packageItems = ref();
const getPackage = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/package/detail/${route.params.uuid}`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            packageItems.value = res.data;
        }
    } finally {
        loader.hide();
    }
};

const save = () => {
    toast.success("Package saved successfully");
    router.push("/packages");
};

onMounted(async () => {
    await getPackage();
});
</script>
